import IconComponent from "icons/IconComponent";

import InformationIcon from "./information-icon.svg";

export default (InformationIcon as any) as IconComponent;
